import React from 'react'
import { Switch } from 'react-router-dom'

import { NotFoundRoute, WonderschoolRouter } from 'framework'
import Loader from 'main/components/common/Loader'
import { App, AuthenticatedRoute } from 'main/framework'
import WSA from 'sdk/sso'

const HeadlessDashboard = React.lazy(() => import('main/pages/Dashboard/HeadlessDashboard'))

function HeadlessRouter() {
  return (
    <React.Suspense fallback={<Loader />}>
      <App>
        <WonderschoolRouter>
          <Switch>
            <AuthenticatedRoute path="/headless/:schoolId(\d+)" component={HeadlessDashboard} />
            <NotFoundRoute />
          </Switch>
        </WonderschoolRouter>
      </App>
    </React.Suspense>
  )
}

export default React.memo(WSA.Components.withWSAuth(HeadlessRouter))
